import React from "react";

const LABEL_COLORS = {
  rose: { bg: "bg-rose-100", text: "text-rose-800", dot: "bg-rose-500" },
  amber: { bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500" },
  orange: { bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500" },
  emerald: { bg: "bg-emerald-100", text: "text-emerald-800", dot: "bg-emerald-500" },
  sky: { bg: "bg-sky-100", text: "text-sky-800", dot: "bg-sky-500" },
  violet: { bg: "bg-violet-100", text: "text-violet-800", dot: "bg-violet-500" },
  fuchsia: { bg: "bg-fuchsia-100", text: "text-fuchsia-800", dot: "bg-fuchsia-500" },
  slate: { bg: "bg-slate-100", text: "text-slate-700", dot: "bg-slate-400" },
};

export const LABEL_COLOR_OPTIONS = Object.keys(LABEL_COLORS);

export const getLabelColors = (color) =>
  LABEL_COLORS[color] ?? LABEL_COLORS.slate;

const BtwLabelPill = ({ label, size = "md", className = "" }) => {
  if (!label) return null;
  const colors = getLabelColors(label.color);
  const sizes =
    size === "sm"
      ? "px-2 py-0.5 text-[10px]"
      : "px-2.5 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${colors.bg} ${colors.text} ${sizes} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${colors.dot}`} />
      {label.name}
    </span>
  );
};

export default BtwLabelPill;
